export enum InstrumentAllocationBasis {
    unknown = 1,
    na = 2,
    percentageOfHolding = 3,
    percentageOfFunding = 4,
    currencyValue = 5,
    unitsQuantity = 6,
}
